"use strict";
/**
 * Top-level reducer for the AI Hub Settings editor.
 *
 * This file is intentionally tiny — it only handles the lifecycle actions
 * (`INIT_FROM_SAVED`, `MARK_SAVED`, `DISCARD_ALL`) and dispatches the rest
 * to focused per-domain reducers:
 *
 *  - {@link ./ai-hub-settings-system-reducer}    `*_SYSTEM*`
 *  - {@link ./ai-hub-settings-workflow-reducer}  `*_WORKFLOW*`
 *  - {@link ./ai-hub-settings-field-reducer}     `*_FIELD*` and `*_MAPPING*`
 *
 * Public types and the `MappingAction` union live in
 * {@link ./ai-hub-settings-reducer-types}; structural-sharing helpers in
 * {@link ./ai-hub-settings-reducer-helpers}. Existing importers (which
 * pull `SettingsAction`, `SystemValueKey`, etc. from this module) keep
 * working unchanged via the re-exports below.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsReducer = exports.createInitialSettingsReducerState = void 0;
var ai_hub_settings_utils_1 = require("./ai-hub-settings-utils");
var ai_hub_settings_reducer_helpers_1 = require("./ai-hub-settings-reducer-helpers");
var ai_hub_settings_field_reducer_1 = require("./ai-hub-settings-field-reducer");
var ai_hub_settings_system_reducer_1 = require("./ai-hub-settings-system-reducer");
var ai_hub_settings_workflow_reducer_1 = require("./ai-hub-settings-workflow-reducer");
exports.createInitialSettingsReducerState = ai_hub_settings_reducer_helpers_1.buildInitialState;
exports.settingsReducer = function (state, action) {
    switch (action.type) {
        case 'INIT_FROM_SAVED':
        case 'MARK_SAVED':
            return ai_hub_settings_reducer_helpers_1.buildInitialState(action.saved);
        case 'DISCARD_ALL':
            return __assign(__assign({}, state), { draft: ai_hub_settings_utils_1.cloneAiHubSettingsSchema(state.saved), newSystemIds: [], newWorkflowIds: [], newFieldIds: [], selectedSystemId: null, selectedWorkflowId: null, selectedFieldId: null });
        default:
            if (ai_hub_settings_system_reducer_1.isSystemAction(action)) {
                return ai_hub_settings_system_reducer_1.systemReducer(state, action);
            }
            if (ai_hub_settings_workflow_reducer_1.isWorkflowAction(action)) {
                return ai_hub_settings_workflow_reducer_1.workflowReducer(state, action);
            }
            if (ai_hub_settings_field_reducer_1.isFieldAction(action)) {
                return ai_hub_settings_field_reducer_1.fieldReducer(state, action);
            }
            return state;
    }
};
